import $ from "jquery";
import CONFIG from "@bd-core/config";

// The global bdjs object
var bdjs = {};

/**
 *  strReplace
 *
 *  Performs a string replace
 *
 *  @param	search search
 *  @param	replace replace
 *  @param	subject subject
 *  @return	string
 */

bdjs.strReplace = function (search, replace, subject) {
  return subject.split(search).join(replace);
};

bdjs.isUndefined = function (value) {
  return typeof value == "undefined";
};

/**
 * @example
 * const object = {
 *  1: { name: "Foo" },
 *  2: { name: "Bar" }
 * };
 * const result = indexedObjectToArray(object);
 * console.log(result);
 * // output: [{ name: "Foo" }, { name: "Bar" }]
 * @param {Object} obj
 */
bdjs.indexedObjectToArray = function (obj) {
  if (!obj) return [];
  if (typeof obj !== "object") return [];
  return Object.keys(obj).map((key) => obj[key]);
};

/**
*  parseArgs
*
*  Merges together defaults and args much like the WP wp_parse_args function

*  @param	{object} args
*  @param	{object} defaults
*  @return	object
*/

bdjs.parseArgs = function (args, defaults) {
  if (typeof args !== "object") args = {};
  if (typeof defaults !== "object") defaults = {};
  return $.extend({}, defaults, args);
};

bdjs.suffixURL = function () {
  const getLang = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    // @ts-ignore
    const params = Object.fromEntries(urlSearchParams.entries());
    return params.lang;
  };

  const lang = getLang();
  return lang ? "?lang=" + lang : "";
};

bdjs.getAllQueryString = function (location) {
  const query = new URLSearchParams(location);
  const result = {};
  query.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};

bdjs.objectToQuerystring = function (obj) {
  const escaped = Object.keys(obj).map((key) => {
    const value = obj[key];
    if (value === undefined || value === null) return "";
    if (Array.isArray(value))
      return value.map((val) => `${key}=${val}`).join("&");
    return `${key}=${obj[key]}`;
  });
  const filtered = escaped.filter((x) => x !== "");
  const querystring = filtered.join("&");

  return querystring;
};

bdjs.redirect = function (url, requestURL) {
  const getQueryParamStr = (thisUrl) => {
    if (typeof thisUrl == "undefined") return;

    return new URL(thisUrl).search;
  };

  const queryParamUrl = getQueryParamStr(url);
  const queryParamRequestUrl = getQueryParamStr(requestURL);

  const parsedQuery1 = bdjs.getAllQueryString(queryParamUrl);
  const parsedQuery2 = bdjs.getAllQueryString(queryParamRequestUrl);
  const mergedQuery = { ...parsedQuery1, ...parsedQuery2 };
  const baseUrl = url.split("?")[0];
  const res =
    baseUrl + "?" + bdjs.objectToQuerystring(mergedQuery).replace("+", "%2B");

  window.location.href = res;
};

// Global block storage
bdjs.blocks = [];

/**
*  registerBlock
*
*  register new bd block.
 
*  @param	{object} block
*  @return	void
*/
bdjs.registerBlock = function (block) {
  bdjs.blocks.push(block);
};

/**
 *  getBlocks
 *
 *  Get all blocks
 *  @return	object
 */

bdjs.getBlocks = function () {
  return bdjs.blocks;
};

/**
 *  getBlock
 *
 *  Get block by type
 *
 *  @param	{string|boolean} type
 *  @return	object
 */

bdjs.getBlock = function (type) {
  var block = null;

  bdjs.blocks.forEach(function (item, index) {
    if (item.type == type) {
      block = bdjs.blocks[index];
    }
  });

  return block;
};

bdjs.removeItemArray = function (arr, value) {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }

  return arr;
};

bdjs.keyLength = function (object) {
  return Object.keys(object).length;
};

bdjs.removeItemOnce = (arr, value) => {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};

bdjs.escapeHtml = function (string) {
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
    "`": "&#x60;",
    "=": "&#x3D;",
  };

  return String(string).replace(/[&<>"'`=/]/g, function (s) {
    //eslint-disable-line no-useless-escape
    return entityMap[s];
  });
};

bdjs.showLoading = function (callback, force = false) {
  if (typeof callback !== "function") return;

  if (
    CONFIG.game_options.transition_between_building_block === "none" &&
    force == false
  ) {
    callback();
  } else {
    if (force) $("#page").removeClass("none-loader");
    $("#page").addClass("is-loading");
    setTimeout(
      function () {
        callback();
      },
      CONFIG.game_options.transition_between_building_block === "milky-layer"
        ? 3000
        : 1000,
    );
  }
};

bdjs.hideLoading = function (callback) {
  setTimeout(() => {
    $("#page").removeClass("is-loading");

    if (typeof callback !== "function") return;

    if (CONFIG.game_options.transition_between_building_block === "none") {
      callback();
    } else {
      setTimeout(function () {
        callback();
      }, 1000);
    }
  }, 200);
};

/**
 * @description ### Returns Go / Lua like responses(data, err)
 * when used with await
 *
 * - Example response [ data, undefined ]
 * - Example response [ undefined, Error ]
 *
 *
 * When used with Promise.all([req1, req2, req3])
 * - Example response [ [data1, data2, data3], undefined ]
 * - Example response [ undefined, Error ]
 *
 *
 * When used with Promise.race([req1, req2, req3])
 * - Example response [ data, undefined ]
 * - Example response [ undefined, Error ]
 *
 * //@type {BD_GoAsync}
 */
bdjs.goAsync = async (promise) => {
  try {
    const result = await promise;
    return [result, undefined];
  } catch (e) {
    return [undefined, e || true];
  }
};

/**
 *  decrypt object
 *
 *  @return	object
 */

bdjs.decryptObject = async function decryptObject(
  encryptedObject,
  encryptionKeyBase64,
) {
  try {
    // Convert base64 key to Uint8Array
    const encryptionKeyBytes = Uint8Array.from(atob(encryptionKeyBase64), (c) =>
      c.charCodeAt(0),
    );

    // Import the key
    const encryptionKey = await crypto.subtle.importKey(
      "raw",
      encryptionKeyBytes,
      "AES-CBC",
      false,
      ["decrypt"],
    );

    // Decode the base64 encoded string
    const encryptedData = Uint8Array.from(atob(encryptedObject), (c) =>
      c.charCodeAt(0),
    );
    const ivLength = 16; // 16 bytes for AES-256-CBC
    const iv = encryptedData.slice(0, ivLength);
    const ciphertext = encryptedData.slice(ivLength);

    // Decrypt the object
    const decryptedData = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv: iv },
      encryptionKey,
      ciphertext,
    );

    // Decode the decrypted data
    const decoder = new TextDecoder();
    const serializedObj = decoder.decode(decryptedData);
    return JSON.parse(serializedObj);
  } catch (error) {
    console.error("Decryption failed:", error);
    throw error;
  }
};

export default bdjs;
